import React, { useContext, useState } from "react";
import { Grid, Row, Col, Jumbotron } from "react-bootstrap";
import { Card } from "components/Card/Card.jsx";
import { FeatureBlueprintContext } from "context/FeatureBlueprintContext";
import { FetchAPI } from "api/fetch";
import { useEffect } from "react";
import BeatLoader from "react-spinners/BeatLoader";
import { GlobalLoadIndicator } from "context/GlobalLoadIndicator";
import { PostAPI } from "api/post.js";
import { loopBackDomain, loopBackPort } from "environment/environment";
import SimpleBarGraph from "components/Graphs/SimpleBarGraph";
import "react-datepicker/dist/react-datepicker.css";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

const PageType7 = props => {
  let [featureBlueprint, setFeatureBlueprint] = useContext(FeatureBlueprintContext);
  let [globalLoadIndicator, setGlobalLoadIndicator] = useContext(GlobalLoadIndicator);
  let pageLayoutDataContext = (featureBlueprint.data == undefined) ? 'undefined' : featureBlueprint.data.featureBlueprintymlData.pageTypes[0].bodyLayout;
  let [pageLayoutData, setPageLayoutData] = useState('undefined');
  const [usedVsUnusedData, setUsedVsUnusedData] = useState({});
  const [monthWiseIOTDataUpd, setMonthWiseIOTDataUpd] = useState({});
  const [monthWiseProductionData, setMonthWiseProductionData] = useState({});
  const [monthWiseDispatchData, setMonthWiseDispatchData] = useState({});
  const [monthWiseReceiveData, setMonthWiseReceiveData] = useState({});
  const [unUsedQRData, setUnUsedQRData] = useState({});
  const [liveVsNonLiveDataUpd, setLiveVsNonLiveDataUpd] = useState({});
  const [productsCategoriesData, setProductsCategoriesData] = useState({});
  const [stackedGraphData, setStackedGraphData] = useState({});
  const [topProductsData, setTopProductsData] = useState({});

  const [startDateFirst, setStartDateFirst] = useState(new Date());
  const [endDateFirst, setEndDateFirst] = useState(new Date());
  const [startDateSecond, setStartDateSecond] = useState(new Date());
  const [endDateSecond, setEndDateSecond] = useState(new Date());
  const [startDateThird, setStartDateThird] = useState(new Date());
  const [endDateThird, setEndDateThird] = useState(new Date());

  useEffect(() => {
    (async () => {
      if (pageLayoutData != 'undefined') {
        let getURL2 = pageLayoutData[13].subComponentsItems.monthWiseData.apiEndPoint+'?year='+new Date().getFullYear();
        let graphDataVal2 = await FetchAPI(getURL2);
        let graphDataValJson2 = await graphDataVal2.json();
        setMonthWiseProductionData(graphDataValJson2.data);
        let getURL3 = pageLayoutData[14].subComponentsItems.dispatchMonthlyData.apiEndPoint+'?year='+new Date().getFullYear();
        let graphDataVal3 = await FetchAPI(getURL3);
        let graphDataValJson3 = await graphDataVal3.json();
        setMonthWiseDispatchData(graphDataValJson3.data);
        let getURL9 = pageLayoutData[11].subComponentsItems.topFiveProducts.apiEndPoint;
        let graphDataVal9 = await FetchAPI(getURL9);
        let graphDataValJson9 = await graphDataVal9.json();
        setTopProductsData(graphDataValJson9);
      }

    })()
  }, [pageLayoutData])

  useEffect(() => {
    if (globalLoadIndicator == '2') {
      setPageLayoutData(pageLayoutDataContext);
    } else if (globalLoadIndicator == '1') {
      setPageLayoutData('undefined');
    }
  }, [globalLoadIndicator]);

  

  useEffect(() => {
    (async () => {
      let url = loopBackDomain + ':' + loopBackPort + '/api/v1/rendering-engines/getFeatureBlueprint';
      const payload = {
        pageTypeID: 7,
        featureID: 1
      };
      cookies.set('feature_id', 1, { path: '/' });
      await setGlobalLoadIndicator('1');
      let response = await PostAPI(url, payload);
      await setFeatureBlueprint(response);
      await setGlobalLoadIndicator('2');
    })()
  }, [])
 
  let commonParameters = {
    customer_id:cookies.get('customer_id'),
    user_id:cookies.get('user_id'),
  }

  const filterDataFirst = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const getURL = pageLayoutData[1].subComponentsItems.usedVsUnused.apiEndPoint+'?start_date='+startDateFirst+'&end_date='+endDateFirst;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setUsedVsUnusedData(filteredDataJson.data);
    return true;
  }
  const filterDataSecond = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const getURL = pageLayoutData[1].subComponentsItems.levelIdsEndPoint+'?start_date='+startDateFirst+'&end_date='+endDateFirst;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    monthWiseIOTDataUpd(filteredDataJson.data);
    return true;
  }
  const filterDataThird = async (e) => {
    e.preventDefault();
    let newgetURL = null;
    const paramString = new URLSearchParams(commonParameters);
    const getURL = pageLayoutData[1].subComponentsItems.levelIdsEndPoint+'?start_date='+startDateFirst+'&end_date='+endDateFirst;
    newgetURL = (`${getURL}&${paramString.toString()}`);
    const filteredData = await FetchAPI(newgetURL);
    const filteredDataJson = await filteredData.json();
    setUsedVsUnusedData(filteredDataJson.data);
    return true;
  }

  return (
    (pageLayoutData != 'undefined') ?

      <div className="content">
                  
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Jumbotron className="custom-header text-center" style={{ backgroundColor: '#ededed' }}>
                <h3>{(pageLayoutData != 'undefined') ? pageLayoutData[10].title : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}</h3>
                <p style={{ fontSize: '10px' }}>{(pageLayoutData != 'undefined') ? pageLayoutData[10].description : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}</p>
              </Jumbotron>

              <Row>
                <Col md={2}></Col>
                <Col md={8}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[11].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[11].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[11].category : 'demo'}
                    content={
                      <>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[11].subComponentsItems.topFiveProducts}
                          updatedData={topProductsData}
                        />}
                      </>
                    }
                  />
                </Col>
                <Col md={2}></Col>
              </Row>

              <Jumbotron className="custom-header text-center" style={{ backgroundColor: '#ededed' }}>
                <h3>{(pageLayoutData != 'undefined') ? pageLayoutData[12].title : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}</h3>
                <p style={{ fontSize: '10px' }}>{(pageLayoutData != 'undefined') ? pageLayoutData[12].description : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}</p>
              </Jumbotron>

              <Row>
                <Col md={12}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[13].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[13].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[13].category : 'demo'}
                    content={
                      <>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[13].subComponentsItems.monthWiseData}
                          updatedData={monthWiseProductionData}
                        />}
                        <div>
                          <table className="table">
                            {(Object.keys(monthWiseProductionData).length !== 0) ?
                              <tbody>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>Month</th>
                                  {pageLayoutData[13].subComponentsItems.monthWiseData.labels.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop}</th>;
                                  })}
                                </tr>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>IOT Count</th>
                                  {monthWiseProductionData.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</th>;
                                  })}
                                </tr>
                              </tbody>
                              : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}
                          </table>
                        </div>
                      </>
                    }
                  />
                </Col>
                <Col md={3}></Col>
              </Row>

              <Row>
                <Col md={12}>
                  <Card
                    id={(pageLayoutData != 'undefined') ? pageLayoutData[14].id : 'demo'}
                    title={(pageLayoutData != 'undefined') ? pageLayoutData[14].title : 'demo'}
                    category={(pageLayoutData != 'undefined') ? pageLayoutData[14].category : 'demo'}
                    content={
                      <>
                        {<SimpleBarGraph totalAllocated={pageLayoutData[14].subComponentsItems.dispatchMonthlyData}
                          updatedData={monthWiseDispatchData}
                        />}
                        <div>
                          <table className="table">
                            {(Object.keys(monthWiseDispatchData).length !== 0) ?
                              <tbody>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>Month</th>
                                  {pageLayoutData[14].subComponentsItems.dispatchMonthlyData.labels.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop}</th>;
                                  })}
                                </tr>
                                <tr>
                                  <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }}>IOT Count</th>
                                  {monthWiseDispatchData.map((prop, key) => {
                                    return <th style={{ fontWeight: '1000', fontSize: '11px', color: '#000' }} key={key}>{prop.toLocaleString(navigator.language, { minimumFractionDigits: 0 })}</th>;
                                  })}
                                </tr>
                              </tbody>
                              : <BeatLoader size={15} margin={3} color={"#36d7b7"} />}
                          </table>
                        </div>
                      </>
                    }
                  />
                </Col>
                <Col md={3}></Col>
              </Row>
            </Col>
          </Row> 
          {/* Coverage & Distribution - QR Codes */}
        </Grid>
      </div>
      : <div className="content">
      <Grid fluid>
        <div className="text-center" style={{ margin:"200px" }}>
          <BeatLoader size={15} margin={3} color={"#3C423C"} /></div>
      </Grid>
      </div>
  );
}

export default PageType7;

